if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const reco = html.querySelector('product-recommendations');
          if (reco && reco.innerHTML.trim().length) {
            this.innerHTML = reco.innerHTML;
          }
        })
        .catch(e => console.error('Recommendations failed:', e));
    }
  });
}